var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { RolesService } from './../../../core/services/roles.service';
import { ActivatedRoute } from '@angular/router';
import { EventEmitter, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { zip, of, Subject } from 'rxjs';
import { filter, flatMap, map, takeUntil } from 'rxjs/operators';
import { LoadingScopeConstraintsAction, SelectScopeCategoryAction, SelectScopeConstraintsAction, selectRoleUserSelections, selectScopeConstraints, selectSelectedRoleScopeCategory, selectSelectedRoleScopeConstraints } from '../../state';
import { DataTableAjaxComponent } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { needsLoading, readParameterFromRouterState, GoAction } from '@app/core';
import { isScopeAdmin, disableMultiSelectRadio, disableSelectAllRadio } from '@app/core/utilities/scopes.helpers';
import { AlertService } from '@app/core/services/alert.service';
import { RoleDetailsFacadeService } from '@app/access-management/state/role-details.facade';
var shouldLoadCategories = function (categories) { return needsLoading(categories); };
var ɵ0 = shouldLoadCategories;
var shouldLoadConstraints = function (constraints) { return needsLoading(constraints); };
var ɵ1 = shouldLoadConstraints;
var RoleScopeOptionsComponent = /** @class */ (function () {
    function RoleScopeOptionsComponent(store, route, rolesService, alertService, roleDetailsFacade) {
        var _this = this;
        this.store = store;
        this.route = route;
        this.rolesService = rolesService;
        this.alertService = alertService;
        this.roleDetailsFacade = roleDetailsFacade;
        this.backTo = ['/iam/roles', this.roleId];
        this.usernames = [];
        this.validityChange = new EventEmitter(false);
        this.optionSelected = new EventEmitter();
        this.saved = new EventEmitter();
        this.categoryId = '0';
        this.columns = [];
        this._category = null;
        this.selectedConstraints = [];
        this.selectedOrganizations = [];
        this.destroy$ = new Subject();
        this.useProjectCommitteeHandler = false;
        this.selectedUsers$ = of([]);
        this.username = readParameterFromRouterState(this.route, 'username');
        this._roleId = readParameterFromRouterState(this.route, 'id');
        this.scopeCategories$ = this.getFilteredRoleScopeCategories(this._roleId);
        this.roleDetailsFacade.initialize(this._roleId);
        this.roleDetailsFacade.role$.pipe(takeUntil(this.destroy$)).subscribe(function (role) {
            _this._roleName = role.name;
        });
        this.roleUserScopes$ = this.username
            ? this.rolesService
                .getRoleUserScopes(this._roleId, this.username)
                .pipe(map(function (list) { return list.map(function (row) { return (__assign({}, row, { id: row.object_id })); }).slice(); }))
            : of([]);
        this.userHasAdminScope$ = this.roleUserScopes$.pipe(map(function (scopes) { return scopes.some(function (scope) { return isScopeAdmin(scope.object_type_name); }); }));
        this.userProjectScope$ = this.roleUserScopes$.pipe(map(function (scopes) {
            return scopes.map(function (scope) {
                var projScope = scope;
                if (scope.id.split('|').length > 1 && scope.object_type_name === 'project|organization') {
                    projScope.id = scope.id.split('|')[0];
                }
                return projScope;
            });
        }));
        this.validatedCategories$ = zip(this.scopeCategories$, this.userHasAdminScope$).pipe(map(function (responses) {
            var scopes = responses[0];
            var userHasAdminScope = responses[1];
            if (!userHasAdminScope) {
                return scopes;
            }
            var newScopes = scopes.map(function (scope) {
                return __assign({}, scope, { disabled: isScopeAdmin(scope.name) });
            });
            return newScopes;
        }));
    }
    RoleScopeOptionsComponent.prototype.ngAfterViewInit = function () {
        this.columns = [
            {
                name: 'Name',
                prop: 'name',
                flexGrow: 2
            }
        ];
        this.scopeCatRef.nativeElement.hidden = true;
    };
    RoleScopeOptionsComponent.prototype.onRowClicked = function (_a) {
        var selected = _a.selected;
    };
    RoleScopeOptionsComponent.prototype.ngOnInit = function () {
        this.selectedScopeCategory$ = this.store.pipe(select(selectSelectedRoleScopeCategory(this.roleId)));
        var selectedCategory$ = this.filterMaybeSelectedCategory();
        this.scopeConstraints$ = this.selectConstraints$(selectedCategory$);
        this.loadConstraintsSubscription = this.loadSelectedCategoryConstraints(selectedCategory$);
        this.selectedScopeConstraints$ = this.store.pipe(select(selectSelectedRoleScopeConstraints(this.roleId)));
        this.selectedUsers$ = this.store.pipe(select(selectRoleUserSelections(this.roleId)), map(function (roleUserSelections) {
            return (roleUserSelections &&
                roleUserSelections.users &&
                roleUserSelections.users.length &&
                roleUserSelections.users.map(function (user) { return user.username; })) ||
                [];
        }));
    };
    RoleScopeOptionsComponent.prototype.ngOnDestroy = function () {
        if (this.loadConstraintsSubscription) {
            this.loadConstraintsSubscription.unsubscribe();
        }
    };
    RoleScopeOptionsComponent.prototype.selectCategory = function (category) {
        this.optionSelected.emit(category.name.toLowerCase());
        if (category.name.toLowerCase() === 'project|committee') {
            this.useProjectCommitteeHandler = true;
            return;
        }
        this.useProjectCommitteeHandler = false;
        if (disableMultiSelectRadio(this._roleName, category.name)) {
            this.multiSelectRef.nativeElement.hidden = true;
            this.scopeCategoryRef.nativeElement.hidden = true;
            this.scopeCatRef.nativeElement.hidden = false;
            this.selectAllRef.nativeElement.hidden = false;
        }
        else if (this.scopeMultipleRef && !isScopeAdmin(category.name)) {
            this.scopeCatRef.nativeElement.hidden = false;
            this.multiSelectRef.nativeElement.hidden = false;
            this.scopeCategoryRef.nativeElement.hidden = false;
            if (category.name.toLowerCase() === 'project|organization') {
                this.categoryId = '1';
                this.scopeMultipleRef.nativeElement.hidden = false;
            }
            else {
                this.categoryId = category.id;
                this.scopeMultipleRef.nativeElement.hidden = true;
            }
            if (disableSelectAllRadio(this._roleName, category.name)) {
                this.selectAllRef.nativeElement.hidden = true;
            }
            else {
                this.selectAllRef.nativeElement.hidden = false;
            }
        }
        else {
            this.scopeCatRef.nativeElement.hidden = true;
        }
        this._category = category;
        this.store.dispatch(new SelectScopeCategoryAction({
            roleId: this.roleId,
            category: category
        }));
        this.allowSaveIfCategoryIsAdmin();
    };
    RoleScopeOptionsComponent.prototype.allowSaveIfCategoryIsAdmin = function () {
        this.validityChange.emit(this.isScopeAdmin());
    };
    RoleScopeOptionsComponent.prototype.isScopeAdmin = function () {
        return this._category && isScopeAdmin(this._category.name);
    };
    RoleScopeOptionsComponent.prototype.onSelectConstraints = function (row) {
        var _this = this;
        var constraints = row.selected;
        if (this._category.name.toLowerCase() === 'organization' && row.selected.length > 1) {
            this.alertService.error('Error: Can select only one organization.');
        }
        else if (this._category.name.toLowerCase() === 'project|organization') {
            if (this.selectedOrganizations.length > 0) {
                this.selectedConstraints = row.selected;
                this.selectedConstraints.map(function (constraint) {
                    var constraintArray = constraint.id.split('|');
                    if (constraintArray.length > 1) {
                        constraint.id = constraintArray[0];
                    }
                    constraint.id = constraint.id + '|' + _this.selectedOrganizations[0];
                });
                this.selectConstraints(this.selectedConstraints);
            }
            else {
                this.selectedConstraints = row.selected;
                this.alertService.error('Please select organization');
            }
        }
        else {
            this.selectConstraints(constraints);
        }
    };
    RoleScopeOptionsComponent.prototype.onSelectMultipleConstraints = function (row) {
        if (row.selected.length > 1) {
            this.alertService.error('Error: Can select only one organization.');
        }
        else if (row.selected.length === 1) {
            var orgaConstraint_1 = row.selected[0];
            this.selectedOrganizations.length = 0;
            this.selectedOrganizations.push(orgaConstraint_1.id);
            this.selectedConstraints.map(function (constraint) {
                var constraintArray = constraint.id.split('|');
                if (constraintArray.length > 1) {
                    constraint.id = constraintArray[0];
                }
                constraint.id = constraint.id + '|' + orgaConstraint_1.id;
            });
            this.selectConstraints(this.selectedConstraints);
        }
        else {
            this.alertService.error('Please select organization');
        }
    };
    RoleScopeOptionsComponent.prototype.selectConstraints = function (constraints) {
        this.store.dispatch(new SelectScopeConstraintsAction({
            roleId: this.roleId,
            constraints: constraints
        }));
        this.validityChange.emit(constraints.length > 0);
    };
    RoleScopeOptionsComponent.prototype.onSelectAll = function (radioBtnEvent, scopeCategoryRef) {
        if (radioBtnEvent.target.checked) {
            scopeCategoryRef.hidden = true;
            var constraints = [{ scopeId: '', id: '*', name: '' }];
            this.store.dispatch(new SelectScopeConstraintsAction({
                roleId: this.roleId,
                constraints: constraints
            }));
            this.validityChange.emit(constraints.length > 0);
        }
    };
    RoleScopeOptionsComponent.prototype.onSelectMultiple = function (radioBtnEvent, scopeCategoryRef) {
        if (radioBtnEvent.target.checked) {
            scopeCategoryRef.hidden = false;
        }
    };
    RoleScopeOptionsComponent.prototype.onSaved = function (value) {
        if (value) {
            this.store.dispatch(new GoAction(this.backTo));
        }
        this.saved.emit(value);
    };
    RoleScopeOptionsComponent.prototype.loadSelectedCategoryConstraints = function (selectedScopeCategory$) {
        var _this = this;
        var scopeConstraintsToLoad$ = this.scopeConstraints$.pipe(filter(shouldLoadConstraints), flatMap(function () { return selectedScopeCategory$; }));
        return scopeConstraintsToLoad$.subscribe(function (category) {
            return _this.store.dispatch(new LoadingScopeConstraintsAction(category.id));
        });
    };
    RoleScopeOptionsComponent.prototype.filterMaybeSelectedCategory = function () {
        return this.selectedScopeCategory$.pipe(filter(function (maybeCategory) { return maybeCategory !== undefined; }));
    };
    RoleScopeOptionsComponent.prototype.selectConstraints$ = function (selectedCategory$) {
        var _this = this;
        return selectedCategory$.pipe(flatMap(function (category) { return _this.store.pipe(select(selectScopeConstraints(category.id))); }));
    };
    RoleScopeOptionsComponent.prototype.getFilteredRoleScopeCategories = function (roleId) {
        return this.rolesService.getRoleObjects(roleId).pipe(map(function (roleObjs) {
            return roleObjs.map(function (role_obj) {
                return { id: role_obj.object_id, name: role_obj.object_name };
            });
        }));
    };
    return RoleScopeOptionsComponent;
}());
export { RoleScopeOptionsComponent };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-scope-options/role-scope-options.component.ts.pre-build-optimizer.js